import React, { useEffect, useState } from 'react';

import PopoutSelector from '../../../../../components/ux/PopoutSelector';
import PopoutIntegerSelector from '../../../../../components/ux/PopoutIntegerSelector';
import _ from 'lodash';

const listRepeaterOptions = [
   { no: 2, name: 'exactly' },
   { no: 3, name: 'at least' },
   { no: 4, name: 'at most' }
];

const freeFlowRepeaterOptions = [
   { no: 5, name: 'any number of' },
   { no: 2, name: 'exactly' },
   { no: 3, name: 'at least' },
   { no: 4, name: 'at most' }
];

const RepeatTimesSelector = (props) => {
   const { id, idRepeaterType = 1, onChange, idRepeaterCadence, timesToRepeat = null } = props;
   const options = idRepeaterType == 1 ? listRepeaterOptions : freeFlowRepeaterOptions;

   const [cadence, setCadence] = useState(idRepeaterCadence);
   const [noTimes, setNoTimes] = useState(timesToRepeat);

   useEffect(() => setCadence(idRepeaterCadence), [idRepeaterCadence]);
   useEffect(() => setNoTimes(timesToRepeat), [timesToRepeat]);

   const selectedOptions = _.filter(options, (option) => option.no == cadence).slice(0, 1);
   const showTimes = [2, 3, 4].some((id) => id == cadence);
   const entryCaption = showTimes ? (noTimes == 1 ? 'entry' : 'entries') : 'entries';

   const onCadenceChange = ({ options: selected }) => {
      if (selected.length === 0) return;

      const nextCadence = selected[0].no;
      if (nextCadence == cadence) return;

      setCadence(nextCadence);
      if (onChange) onChange({ idRepeaterCadence: nextCadence, timesToRepeat: noTimes });
   };

   const onTimesChanged = ({ value }) => {
      if (value === noTimes) return;

      setNoTimes(value);
      if (onChange) onChange({ idRepeaterCadence: cadence, timesToRepeat: value });
   };

   const idControl = id ? id : 'repeat-times-selector';
   const idPopout = id ? id + '-popout' : 'repeat-times-selector-popout';
   const idPopoutNo = id ? id + '-popout-no' : 'repeat-times-selector-popout-no';

   return (
      <div id={idControl} className={'RepeatTimesSelector'}>
         <PopoutSelector
            required
            showAsChip
            readOnly={false}
            id={idPopout}
            label={''}
            options={options}
            selectedOptions={selectedOptions}
            onChange={onCadenceChange}
            popoverClassName='repeater-selector-popover'
         />
         {showTimes && (
            <PopoutIntegerSelector
               popoverClassName='int-repeater-selector-popover'
               required
               showAsChip
               max={100}
               min={1}
               readOnly={false}
               id={idPopoutNo}
               label='times'
               value={noTimes}
               onChange={onTimesChanged}
            />
         )}
         <span className='caption'>{entryCaption}</span>
      </div>
   );
};

export default RepeatTimesSelector;
